<template>
    <div class="flex gap-2">
        <div
            v-for="(img, index) in pdfImage"
            :key="img.image_id"
            class="group relative h-20 w-20 cursor-pointer border border-grey-40 px-1 py-1.5"
        >
            <img
                :src="img.fulltext_image240_url"
                width="120"
                height="120"
                loading="lazy"
                @click="()=>handleOpenImagePanel(index)"
                class="h-full object-contain"
            />

            <img
                :src="img.storage_path"
                width="120"
                loading="lazy"
                height="120"
                class="absolute left-0 top-20 z-10 hidden h-[348px] min-w-[520px] border border-grey-40 bg-white object-contain px-[100px] py-4 group-hover:block"
            />
        </div>

        <a class="flex h-20 items-center justify-center bg-grey-20 px-2 text-xs"
           v-if="haveMore"
           @click="()=>handleOpenImagePanel(4)"
        >
            {{ $t('more') }}
        </a>
    </div>
</template>

<script setup lang="ts">
import type { IBaseSolution } from '@/types';
import { cloneDeep } from 'lodash';
import { computed } from 'vue';
import type { ImageRecord } from '@/types'
const MAX_IMAGE_SHOW = 4;

const props = defineProps<{
  solutionProfile: IBaseSolution;
}>();

const pdfImage = computed(() => {
    const imageOrigin = cloneDeep(props.solutionProfile?.pdf_image)
    return imageOrigin?.splice(0, MAX_IMAGE_SHOW) as ImageRecord[]
})

const haveMore = computed(() => {
    if (!props.solutionProfile?.pdf_image_count) return false
    return props.solutionProfile?.pdf_image_count > MAX_IMAGE_SHOW
})

const emits = defineEmits<{
    (e: 'openImagePanel', value: {
      images?: ImageRecord[],
      order?: number
    }): void
}>()

function handleOpenImagePanel(index?:number) {
    if (!pdfImage.value.length) return;
    emits('openImagePanel', {
        images: props.solutionProfile?.pdf_image,
        order: index,
    })
}
</script>
